import React from 'react';

const QuickviewImageLoadingComponent = ({ variant = 'Desktop' }) => {
  const generateThumbnails = (count, className) => (
    <div className={`quickview-thumbnails-loading ${className}`}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={`quickview-thumbnail-image-loading skeleton ${className}`} />
      ))}
    </div>
  );
  const DesktopVariant = (
    <>
      <div className="quickview-image-loading skeleton" alt="" />
      {generateThumbnails(7, 'desktop-loading')}
    </>
  );

  // Mobile image variant
  const MobileImageVariant = (
    <div className="quickview-image-mobile-loading" />
  );

  const getVariant = {
    desktop: DesktopVariant,
    mobileThumbnails: generateThumbnails(8, ''),
    mobileImage: MobileImageVariant,
  };

  return (
    getVariant[variant] || getVariant.desktop
  );
};

export default QuickviewImageLoadingComponent;
